module.exports = __webpack_public_path__ + "aeb0c149651b6dd3379bdd9c7ab3c9d6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-22.png
// module id = 1432
// module chunks = 0